/*
 * @Author: your name
 * @Date: 2021-05-14 10:57:36
 * @LastEditTime: 2021-05-18 09:50:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /hdl-open-pc/src/utils/auth.ts
 */

import Cookies from 'js-cookie'
const TokenKey = 'vue_admin_template_token'


// export const SERVER_URL = "http://10.220.173.60:9007"

export let SERVER_URL = ""
if (window.location.href.indexOf('newvmall.haidilao.com') > -1) {
    SERVER_URL = ""
} else {
    SERVER_URL = ""
}

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token: string) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


export function checkPhone(phone: string) {
    return !(/^1[3456789]\d{9}$/.test(phone))
}

/**
* 校验数字和短横线
**/
export function checkPhoneNum(phone: string) {
    var isPhone = /^([0-9-]+)$/
    if (isPhone.test(phone)) {
        return true
    } else {
        return false
    }
}

export function checkNum(num: any) {
    if (!(/(^[1-9]\d*$)/.test(num))) {
        return true
    } else {
        return false;
    }
}
export function integerNum(num: any) {
    if (!(/^(0|\+?[1-9][0-9]*)$/.test(num))) {
        return true
    } else {
        return false;
    }
}
export function illegalReg(num: any) {
    let illegal = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|[\uA9|\uAE]\u3030|\u3030|[<>]/
    if (illegal.test(num)) {
        return true
    } else {
        return false
    }
}

export function ipRules(value: any) {
    let reg = /^((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9]))$/
    if (reg.test(value)) {
        return true
    } else {
        return false
    }
}
export function checkONum(value: any) {
    var reg = /^([1-9]\d*|[0]{1,1})$/; //含0正整数
    if (reg.test(value)) {
        return true
    } else {
        return false
    }
}
export function checkMobile(phone: any) {
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
        // alert("手机号码有误，请重填");  
        return false;
    }
}
//验证正整数 大于0的正整数
export function checkIsPositiveIntegerEx0(value: any) {
    var reg = /^([1-9][0-9]*)$/
    if (reg.test(value)) {
        return true
    } else {
        return false
    }
};